import React from 'react';
// ANT
import Icon from 'components/common/Icon';

const BackButton = ({ onBack }) => {
  return (
    <div style={{ textAlign: 'center', marginTop: 25 }}>
      <a size="large" style={{ margiRight: 10, fontSize: 14 }} onClick={() => onBack()}>
        <Icon type="left" style={{ marginRight: 3 }} />
        GO BACK
      </a>
    </div>
  );
};

export default BackButton;



// WEBPACK FOOTER //
// ./src/routes/contract-draft/BackButton/index.js